import React from "react";
var __jsx = React.createElement;
import { useEffect, useState } from "react";
import useDebounce from "@/common/hooks/useDebounce";
var OilQuantityControl = function OilQuantityControl(_ref) {
  var count = _ref.count,
    onDecrease = _ref.onDecrease,
    onIncrease = _ref.onIncrease,
    onSetCount = _ref.onSetCount;
  var _useState = useState(String(count)),
    draft = _useState[0],
    setDraft = _useState[1];
  var debouncedDraft = useDebounce(draft, 500);

  // sync local draft when count changes from outside (+/- buttons, clamp)
  useEffect(function () {
    setDraft(String(count));
  }, [count]);

  // commit debounced keyboard input
  useEffect(function () {
    var parsed = debouncedDraft === "" ? 0 : parseInt(debouncedDraft, 10);
    if (Number.isNaN(parsed) || parsed === count) return;
    onSetCount(parsed);
  }, [debouncedDraft]);
  return /*#__PURE__*/React.createElement("div", {
    className: "py-2 px-1 bg-white flex items-center border border-[#3C56D4] rounded overflow-hidden flex-shrink-0"
  }, /*#__PURE__*/React.createElement("button", {
    className: "bg-transparent border-none cursor-pointer text-base font-bold text-[#3C56D4] px-2 py-1 leading-none ",
    onClick: onIncrease,
    "aria-label": "increase quantity"
  }, "+"), /*#__PURE__*/React.createElement("input", {
    type: "number",
    inputMode: "numeric",
    className: "text-[13px] font-bold text-[#1B2035] w-[28px] min-w-[20px] text-center bg-transparent border-none outline-none p-0 [appearance:textfield] [&::-webkit-outer-spin-button]:appearance-none [&::-webkit-inner-spin-button]:appearance-none",
    value: draft,
    onChange: function onChange(e) {
      return setDraft(e.target.value);
    },
    "aria-label": "quantity"
  }), /*#__PURE__*/React.createElement("button", {
    className: "bg-transparent border-none cursor-pointer text-base font-bold text-[#3C56D4] px-2 py-1 leading-none ",
    onClick: onDecrease,
    "aria-label": "decrease quantity"
  }, "-"));
};
export default OilQuantityControl;